import classNames from "classnames";
import React from "react";
import { UpsellPanelSteps } from "../../../../constants/upsellPanelEnumsAndConstants";
import { isInvestsmartDomain } from "../../../../utils/utils";
import { useUpsellWidgetContainer } from "../../hooks/useUpsellWidgetContainerContext";

export const Step18PricingPanel = () => {
    const { currentStep, boldClass, goToStep } = useUpsellWidgetContainer();
    if (currentStep !== UpsellPanelSteps.Step18PricingPanel) {
        return null;
    }
    const { isAuthenticated } = useAuth();
    return (
        <div>
            {!isAuthenticated && (
                <div className="row mb-3 d-flex">
                    <div className="col-6 pr-0">
                        <a
                            href="#"
                            className={classNames(
                                'text-color-gray-16 full-width d-block py-2 border-bottom-4-gray-21-with-hover font-19',
                                boldClass,
                                'hover-color-brand-green'
                            )}
                            onClick={() => goToStep(UpsellPanelSteps.Step1SignUp)}
                        >
                            Sign up
                        </a>
                    </div>
                    <div className="col-6 pl-0">
                        <div
                            className={classNames(
                                'text-color-deep-blue-2 full-width d-block py-2 font-19',
                                { "border-bottom-4-deep-blue-2": isInvestsmartDomain() },
                                { "border-bottom-4-gray-51": !isInvestsmartDomain() },
                                boldClass)}
                        >
                            Purchase
                        </div>
                    </div>
                </div>
            )}

            {/* "~/Areas/MyAccounts/Views/Subscription/_OrderDetailsCouponCode.cshtml" */}
            {/* "~/Areas/MyAccounts/Views/Subscription/_OrderDetailsPaidSub.cshtml" */}

            <div className="col-md-12">
                <div className="row row-sm">
                    <div className="col col-xs-12 col-sm-12 col-sm">
                        <button
                            className={classNames(
                                'mb-0 btn btn-primary btn-fw font-19-no-line-height',
                                boldClass
                            )}
                            onClick={() => (console.log("Continue clicked!"))}
                        >
                            Continue
                        </button>
                    </div>
                </div>
            </div>

            {!isAuthenticated && (
                <div className="mt-4 mx-auto font-17-sm-down">
                    Already a member?{" "}
                    <a
                        href="#"
                        className="link-primary"
                        onClick={() => goToStep(UpsellPanelSteps.Step3Login)}
                    >
                        Log in
                    </a>
                </div>
            )}
        </div>
    );
};

